import React from 'react';

import { Search as SearchIcon } from '@mui/icons-material';
import { Button, ButtonProps, useMediaQuery, useTheme } from '@mui/material';

import { useIntl } from '@klokhuis/core/Intl';

import styles from './SubmitButton.module.css';

export const SubmitButton = (props: ButtonProps) => {
  const { T } = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Button
      variant="contained"
      type="submit"
      size="large"
      className={styles.root}
      data-testid="submit-button"
      disableElevation
      {...props}
    >
      <SearchIcon className={styles.icon} />
      {isMobile && <span className={styles.label}>{T('lbl.search')}</span>}
    </Button>
  );
};
